module.exports = __webpack_public_path__ + "static/media/cancel.21d8e6d6.svg";